module.exports = __webpack_public_path__ + "static/media/banner-4.081431e3.jpg";